// /*
// * used for displaying password input value
// * just add "init-show-hide-password" directive to switcher element
// */
angular
    .module('app')
    .directive('dropdownDay', DropdownDay);

DropdownDay.$inject = [];
function DropdownDay() {
    function getDays(){
        var days = [];
        for (var i = 0; i < 31; i++) {
            days.push(i+1);
        }
        return days;
    }
    return {
        restrict: 'A',
        scope: {
            ngModel: '=',
        },
        link: function(scope, element, attrs){
            scope.days = getDays();
        },
        template:   '<label class="small" translate>Day</label>' + 
                    '<select class="form-control input-sm" ng-model="ngModel">' + 
                    '<option value="" translate>Any</option>' + 
                    '<option ng-repeat="d in days" value="{{d}}">{{d}}</option>' +
                    '</select>'
    };
}
